import script from "./PrenotaAppuntamento.vue?vue&type=script&setup=true&lang=js"
export * from "./PrenotaAppuntamento.vue?vue&type=script&setup=true&lang=js"

import "./PrenotaAppuntamento.vue?vue&type=style&index=0&id=45dae851&scoped=true&lang=css"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45dae851"]])

export default __exports__